import DataTable from 'datatables.net-dt';
// import 'datatables.net-responsive-dt'
import 'datatables.net-buttons-dt';
import * as select2 from 'select2'
import {each} from "uikit/src/js/util";
export default {
  init() {
    // JavaScript to be fired on the home page

    function downloadCSV() {
      //start with string to force UTF-8 BOM on Excel
      var csv = [];
      var rows = document.querySelectorAll('table tr');

      for (var i = 0; i < rows.length; i++) {
        var row = [], cols = rows[i].querySelectorAll('td, th');

        for (var j = 0; j < cols.length; j++) {

          var linkColumns = [0,1];
          var link = cols[j].querySelector('a');
          if ( link ) {
            row.push(cols[j].querySelector('a').href);
          } else {
            row.push(cols[j].innerText.replace(/&nbsp;/g, ' '));
          }

        }
        if(i === 0) {
          csv.push('\uFEFF' + row.join(','));
        } else {
          csv.push(row.join(','));
        }
      }

      // Download CSV
      var csvFile = new Blob([csv.join('\n')], { type: 'text/csv' });
      var downloadLink = document.createElement('a');
      downloadLink.download = 'table.csv';
      downloadLink.href = window.URL.createObjectURL(csvFile);
      downloadLink.style.display = 'none';
      document.body.appendChild(downloadLink);
      downloadLink.click();
    }

    $('#downloadCSV').on( 'click', function( event ) {
      event.preventDefault();
      downloadCSV();
    });


    function removeDuplicates(arr) {
      return arr.filter((item,
                         index) => arr.indexOf(item) === index);
    }

    let table = new DataTable('#pageIndex-filter', {
      order: [6, 'desc'],
      fixedColumns: true,
      pageLength: 25,
      lengthMenu: [10, 25, 50, 75, 100, 500, 1000],
      buttons: [
        'copy', 'excel', 'pdf',
      ],
      layout: {
        topStart: 'buttons',
      },
      language: {
        searchPlaceholder: 'Search...',
      },

      initComplete: function () {
        let filterWrapper = $('#pageIndex-filter_wrapper');
        filterWrapper.prepend('<div id="filter-controls"><button id="filter-reset" class="uk-border-rounded uk-button uk-button-secondary uk-margin-small-right">Reset</button></div>');
        filterWrapper.prepend('<div id="filter-dropdowns"></div>');

        $('div#filter-controls').wrapAll('<div class="dataTables_filters"></div>');
        $('.dataTables_filters').append($('div#pageIndex-filter_filter')).append($('div#filter-dropdowns')).append($('div#pageIndex-filter_length'));

        this.api()
          .columns()
          .every(function (index) {
            let column = this;
            let selectFilters = [3, 4, 5, 6];
            if ( selectFilters.includes(index) ) {
              // Create select element
              let select = document.createElement('select');
              let selectName = $(column.header()).text().trim();

              select.setAttribute('class', 'dt-select2 '+selectName);
              select.add(new Option(selectName, ''));
              $('#filter-dropdowns').append(select);

              $(select).select2();


              $(select).on('select2:select', function (e) {
                $(select).trigger('change');
                // console.log(select.value);
                // let val = $("<textarea></textarea>").html(DataTable.util.escapeRegex(select.value)).text();
                // var val = DataTable.util.escapeRegex(select.value);

                var div = document.createElement("div");
                div.innerHTML = select.value;
                let val = div.innerText;
                column
                  .search(val ? '.*' + val + '.*' : '', true, false)
                  .draw();
              });

              // Apply listener for user change in value
              // select.addEventListener('change', function () {
              //   var val = DataTable.util.escapeRegex(select.value);
              //
              //   alert('change');
              //   column
              //     .search(val ? '^' + val + '$' : '', true, false)
              //     .draw();
              // });

              // if(index === 1 || index === 4 || index === 5|| index === 6) {
              // if(index === 4 || index === 5) {
                column
                  .data()
                  .unique()
                  .sort()
                  .each(function (d) {
                    let tests = d.split(', ');
                    tests.forEach(element => {
                      let text =  $("<textarea></textarea>").html(element).text();
                      let exists = false;
                      for (let i = 0; i < select.length; ++i){
                        if (select.options[i].value === text){
                          exists = true;
                        }
                      }
                      if(!exists) {
                        select.add(new Option( text ) );
                      }
                    });
                  });

              // }
              // } else {
              //
              // column
              //   .data()
              //   .unique()
              //   .sort()
              //   .each(function (d, j) {
              //     select.add(new Option( $("<textarea></textarea>").html(d).text()));
              //   });
              //
              // }

            }
          });
        //
        // $('.dt-select2.Year ').select2({
        //   sorter: data => data.sort((a, b) =>b.text.localeCompare(a.text)),
        //   escapeMarkup: function (text) { return text; },
        // });
        $('.dt-select2').select2({
          escapeMarkup: function (text) { return text; },
          // debug: true,
        });

      },
      drawCallback: function() {
        // $('.dt-select2').select2();
      },
    });


    new DataTable.Buttons(table, {
      buttons: [
        'copy', 'excel', 'pdf',
      ],
    });


    $('span.filter-button[data-filter]').on('click', function () {
      let col = $(this).data('column'),
        colClass = $(this).data('class'),
        filter = $(this).data('filter');
      table.columns(col).search(filter).draw();
      $('.dt-select2.'+colClass).val(filter).trigger('change').trigger('change');
    });


    $('#filter-reset').on('click', function () {
      table.columns().search('').draw();
      $('.dt-select2').val(null).trigger('change').trigger('change');
    });

  },

  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/pageIndexTable.js